$(function () {
    'use strict';

    const timePeriods = RivalIQ.state.timePeriods;
    RivalIQ.apps.Shell.execute('show:app', {
        app: RivalIQ.apps.LandscapeSettings,
        components: {
            companySets: {
                disabled: true
            },
            timePeriod: timePeriods.getDefinitionByType(timePeriods.types.NOT_AVAILABLE)
        }
    });
});
